import {PageContentList} from "./PageContentList";
import {PageContentEdit} from "./PageContentEdit";
import {PageContentCreate} from "./PageContentCreate";

export default {
    list: PageContentList,
    create: PageContentCreate,
    edit: PageContentEdit
};
